import { ST_PAGE_TOPIC_CHAR_LIMIT } from '@lessonPlanner/constants';

import { TextField, RemoveButton, RemoveButtonVariant } from '../form-fields';

interface Props {
  id: string;
  label: string;
  name: string;
  value: string;
  canDelete: boolean;
  error: string;
  onRemove: () => void;
  onChange: (value: string) => void;
  onBlur: () => void;
}

const InputTopic = (props: Props) => {
  const {
    id,
    name,
    label,
    canDelete,
    error,
    value,
    onBlur,
    onChange,
    onRemove,
  } = props;

  return (
    <div className="flex items-end pb-3">
      <TextField
        className="w-[400px]"
        errorMessage={error}
        id={id}
        label={label}
        maxLength={ST_PAGE_TOPIC_CHAR_LIMIT}
        name={name}
        placeholder="Input the topic for this test"
        type="topic"
        value={value}
        onBlur={onBlur}
        onChange={(e) => onChange(e.target.value)}
      />
      {canDelete && (
        <RemoveButton
          hasError={!!error}
          variant={RemoveButtonVariant.FORM_FIELD}
          onClick={onRemove}
        />
      )}
    </div>
  );
};

export default InputTopic;
